import styled from '@emotion/styled';
import { Button } from '@kizen/kds/Button';
import { CardBasic } from 'components/Card/Card';
import { ContentWidth } from 'components/Layout/PageContentWidth';
import CustomFieldsBuilder from 'components/Builders/CustomFieldsBuilder';
import { TextEllipsisWithTooltip } from 'components/Kizen/Table';
import useExportFieldMetadata from 'hooks/useExportFieldMetadata';
import { useTranslation } from 'react-i18next';
import { PreviewCreateEntityModalButton } from 'components/Modals/CreateEntity/FullForm';
import { RightHeader } from '../styles';

const BigCard = styled(CardBasic)`
  padding-top: 15px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  > div:last-of-type {
    flex: 1;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 6px;
  h3 {
    margin-top: -1px; // Design nudge
    line-height: 1; // Sidestep bootstrap
  }
`;

const BigTitle = styled.div`
  align-items: flex-start;
  width: 0;
  flex-grow: 1;
  h3 {
    margin-top: 4px;
  }
  div {
    margin-top: -3px;
    margin-left: auto;
    & > button {
      margin-left: 20px !important;
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CategoriesLayout = ({
  categories,
  model,
  handleGetCategories,
  field,
  onOpenEditFieldOptions,
  onCloseEditFieldOptions,
  ...props
}) => {
  const { t } = useTranslation();
  const { handleFieldExport } = useExportFieldMetadata({ model });

  return (
    <BigCard as={ContentWidth} {...props}>
      <Header>
        <BigTitle as={TitleWrapper}>
          <TextEllipsisWithTooltip as="h3" type="subheader">
            {t('{{entityName}} Fields', model)}
          </TextEllipsisWithTooltip>
        </BigTitle>
        <RightHeader>
          <PreviewCreateEntityModalButton model={model} className="pb-[10px]" />
          <Button
            className="pb-[10px]"
            color="secondary"
            onClick={handleFieldExport}
            variant="text"
          >
            {t('Export Field Metadata')}
          </Button>
        </RightHeader>
      </Header>
      <CustomFieldsBuilder
        model={model}
        field={field}
        rawCategories={categories}
        updateCategories={handleGetCategories}
        onOpenEditFieldOptions={onOpenEditFieldOptions}
        onCloseEditFieldOptions={onCloseEditFieldOptions}
      />
    </BigCard>
  );
};

export default CategoriesLayout;
